// 店舗形態(usage_type) の enum: admin OpenAPI schema 上
// "permanent"(常設) | "event"(催事) | "mobile"(移動) | "public"(公的)
// 店舗ごと(per-shop)の属性。フロントでは必須入力とする。
export const USAGE_TYPE = {
  PERMANENT: 'permanent',
  EVENT: 'event',
  MOBILE: 'mobile',
  PUBLIC: 'public',
} as const;

export type UsageType = (typeof USAGE_TYPE)[keyof typeof USAGE_TYPE];

export const USAGE_TYPE_LABELS: Record<UsageType, string> = {
  [USAGE_TYPE.PERMANENT]: '常設',
  [USAGE_TYPE.EVENT]: '催事',
  [USAGE_TYPE.MOBILE]: '移動',
  [USAGE_TYPE.PUBLIC]: '公的',
};

// フォームの select 用オプション（表示順）。
export const USAGE_TYPE_OPTIONS: { value: UsageType; label: string }[] = [
  { value: USAGE_TYPE.PERMANENT, label: USAGE_TYPE_LABELS[USAGE_TYPE.PERMANENT] },
  { value: USAGE_TYPE.EVENT, label: USAGE_TYPE_LABELS[USAGE_TYPE.EVENT] },
  { value: USAGE_TYPE.MOBILE, label: USAGE_TYPE_LABELS[USAGE_TYPE.MOBILE] },
  { value: USAGE_TYPE.PUBLIC, label: USAGE_TYPE_LABELS[USAGE_TYPE.PUBLIC] },
];

// 未設定(nil)を含めた値を安全にラベル化する。未知値・空はそのまま返す。
export const usageTypeLabel = (value: string | null | undefined): string => {
  if (!value) return '';
  return USAGE_TYPE_LABELS[value as UsageType] ?? value;
};
